
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiResizeVerticalTop as ObiResizeVerticalTopElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-resize-vertical-top.js';
 
 
 

 
 export const ObiResizeVerticalTop = createComponent({
   react: React,
   tagName: 'obi-resize-vertical-top',
   elementClass: ObiResizeVerticalTopElement,
   events: {
     
   }
  });
 
 